/* Pawsome theme scripts */
document.documentElement.classList.remove('no-js');

document.addEventListener('click', (e) => {
  // Mobile drawer
  const toggle = e.target.closest('[data-drawer-toggle]');
  if (toggle) {
    const drawer = document.getElementById('MobileDrawer');
    if (drawer) {
      const open = drawer.classList.toggle('is-open');
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }
  // Search toggle
  const searchBtn = e.target.closest('[data-search-toggle]');
  if (searchBtn) {
    const bar = document.getElementById('HeaderSearch');
    if (bar) {
      bar.classList.toggle('is-open');
      const input = bar.querySelector('input');
      if (input && bar.classList.contains('is-open')) input.focus();
    }
  }
  // Quantity +/- buttons
  const qtyBtn = e.target.closest('[data-qty]');
  if (qtyBtn) {
    const input = qtyBtn.parentElement.querySelector('input');
    const step = qtyBtn.dataset.qty === 'plus' ? 1 : -1;
    const min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  // Product thumbnails
  const thumb = e.target.closest('[data-thumb]');
  if (thumb) {
    const main = document.querySelector('.js-main-image');
    if (main) {
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset || '';
    }
    document.querySelectorAll('[data-thumb]').forEach((b) => b.classList.toggle('is-active', b === thumb));
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const drawer = document.getElementById('MobileDrawer');
    if (drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }
});

// Collection sort
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-sort-by]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }
});

// Variant picker
class VariantPicker extends HTMLElement {
  connectedCallback() {
    this.variants = JSON.parse(this.querySelector('[type="application/json"]').textContent);
    this.form = document.getElementById(this.dataset.form);
    this.addEventListener('change', () => this.update());
  }
  update() {
    const selected = Array.from(this.querySelectorAll('fieldset')).map(
      (fs) => (fs.querySelector('input:checked') || {}).value
    );
    const variant = this.variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
    const button = this.form.querySelector('[type="submit"]');
    const priceEl = document.querySelector('[data-product-price]');
    if (!variant) {
      button.disabled = true;
      button.textContent = button.dataset.unavailable;
      return;
    }
    this.form.querySelector('[name="id"]').value = variant.id;
    button.disabled = !variant.available;
    button.textContent = variant.available ? button.dataset.add : button.dataset.soldout;
    if (priceEl) {
      const fmt = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: priceEl.dataset.currency });
      priceEl.innerHTML = variant.compare_at_price > variant.price
        ? `<span class="price--sale">${fmt(variant.price)}</span><s>${fmt(variant.compare_at_price)}</s>`
        : fmt(variant.price);
    }
    if (variant.featured_image) {
      const main = document.querySelector('.js-main-image');
      if (main) { main.src = variant.featured_image.src; main.removeAttribute('srcset'); }
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }
}
customElements.define('variant-picker', VariantPicker);
